module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.strategyDialogTitle,
      "width": "1100px",
      "modal-append-to-body": false,
      "custom-class": "ad-add-strategy-dialog",
      "close-on-click-modal": false
    },
    on: {
      "closed": _vm.handleDialogClosed
    },
    model: {
      value: (_vm.visibleProxy),
      callback: function($$v) {
        _vm.visibleProxy = $$v
      },
      expression: "visibleProxy"
    }
  }, [_c('div', {
    staticClass: "strategy-dialog-body"
  }, [_c('div', {
    staticClass: "strategy-dialog-form"
  }, [_c('el-form', {
    ref: "addFormRef",
    attrs: {
      "model": _vm.addForm,
      "label-position": "left",
      "label-width": "110px"
    }
  }, [_c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 策略名称\n               ")]), _vm._v(" "), _c('div', {
    staticClass: "strategy-name-row"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入策略名称",
      "clearable": ""
    },
    on: {
      "blur": _vm.validateStrategyName
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  }), _vm._v(" "), (_vm.isDuplicateStrategyName) ? _c('div', {
    staticClass: "strategy-name-duplicate-tip"
  }, [_vm._v("\n                     策略名称不允许重复\n                  ")]) : _vm._e()], 1)], 2), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 生效时间\n               ")]), _vm._v(" "), _c('div', {
    staticClass: "effect-time-row"
  }, [_c('div', {
    staticClass: "form-radio-group"
  }, [_c('el-radio', {
    attrs: {
      "label": "forever"
    },
    model: {
      value: (_vm.addForm.effectTimeType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "effectTimeType", $$v)
      },
      expression: "addForm.effectTimeType"
    }
  }, [_vm._v("永久")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "range"
    },
    model: {
      value: (_vm.addForm.effectTimeType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "effectTimeType", $$v)
      },
      expression: "addForm.effectTimeType"
    }
  }, [_vm._v("有效期")])], 1), _vm._v(" "), (_vm.addForm.effectTimeType === 'range') ? _c('div', {
    staticClass: "effect-time-range"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择开始日期/时间",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "clearable": false
    },
    model: {
      value: (_vm.addForm.effectStart),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "effectStart", $$v)
      },
      expression: "addForm.effectStart"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "range-sep"
  }, [_vm._v("-")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择结束日期/时间",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "clearable": false
    },
    model: {
      value: (_vm.addForm.effectEnd),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "effectEnd", $$v)
      },
      expression: "addForm.effectEnd"
    }
  })], 1) : _vm._e()])], 2), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 生效系统\n               ")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.addForm.systemType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "systemType", $$v)
      },
      expression: "addForm.systemType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "all"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "ios"
    }
  }, [_vm._v("iOS")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "hongmeng"
    }
  }, [_vm._v("鸿蒙")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "android"
    }
  }, [_vm._v("安卓")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "section-title"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" APP广告位")]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-split"
  }, [_c('div', {
    staticClass: "app-ad-row"
  }, [_c('div', {
    staticClass: "app-ad-left"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 开屏")]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-switch"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#409eff",
      "inactive-color": "#c0c4cc"
    },
    model: {
      value: (_vm.addForm.appAds.openSplash.enabled),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.openSplash, "enabled", $$v)
      },
      expression: "addForm.appAds.openSplash.enabled"
    }
  })], 1)]), _vm._v(" "), (_vm.addForm.appAds.openSplash.enabled) ? _c('div', {
    staticClass: "interval-grid"
  }, [_c('div', {
    staticClass: "interval-line"
  }, [_c('div', {
    staticClass: "interval-label"
  }, [_vm._v("冷启动间隔")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 9999,
      "step": 1,
      "precision": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.addForm.appAds.openSplash.cold),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.openSplash, "cold", $$v)
      },
      expression: "addForm.appAds.openSplash.cold"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "interval-unit",
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.addForm.appAds.openSplash.coldUnit),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.openSplash, "coldUnit", $$v)
      },
      expression: "addForm.appAds.openSplash.coldUnit"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "秒",
      "value": "sec"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "分钟",
      "value": "min"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小时",
      "value": "hour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "天",
      "value": "day"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "interval-line"
  }, [_c('div', {
    staticClass: "interval-label"
  }, [_vm._v("热启动间隔")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 9999,
      "step": 1,
      "precision": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.addForm.appAds.openSplash.hot),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.openSplash, "hot", $$v)
      },
      expression: "addForm.appAds.openSplash.hot"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "interval-unit",
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.addForm.appAds.openSplash.hotUnit),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.openSplash, "hotUnit", $$v)
      },
      expression: "addForm.appAds.openSplash.hotUnit"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "秒",
      "value": "sec"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "分钟",
      "value": "min"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小时",
      "value": "hour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "天",
      "value": "day"
    }
  })], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-split"
  }, [_c('div', {
    staticClass: "app-ad-row"
  }, [_c('div', {
    staticClass: "app-ad-left"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 首页-插屏")]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-switch"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#409eff",
      "inactive-color": "#c0c4cc"
    },
    model: {
      value: (_vm.addForm.appAds.homePop.enabled),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.homePop, "enabled", $$v)
      },
      expression: "addForm.appAds.homePop.enabled"
    }
  })], 1)]), _vm._v(" "), (_vm.addForm.appAds.homePop.enabled) ? _c('div', {
    staticClass: "interval-grid"
  }, [_c('div', {
    staticClass: "interval-line"
  }, [_c('div', {
    staticClass: "interval-label"
  }, [_vm._v("冷启动间隔")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 9999,
      "step": 1,
      "precision": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.addForm.appAds.homePop.cold),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.homePop, "cold", $$v)
      },
      expression: "addForm.appAds.homePop.cold"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "interval-unit",
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.addForm.appAds.homePop.coldUnit),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.homePop, "coldUnit", $$v)
      },
      expression: "addForm.appAds.homePop.coldUnit"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "秒",
      "value": "sec"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "分钟",
      "value": "min"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小时",
      "value": "hour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "天",
      "value": "day"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "interval-line"
  }, [_c('div', {
    staticClass: "interval-label"
  }, [_vm._v("热启动间隔")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 9999,
      "step": 1,
      "precision": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.addForm.appAds.homePop.hot),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.homePop, "hot", $$v)
      },
      expression: "addForm.appAds.homePop.hot"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "interval-unit",
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.addForm.appAds.homePop.hotUnit),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.homePop, "hotUnit", $$v)
      },
      expression: "addForm.appAds.homePop.hotUnit"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "秒",
      "value": "sec"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "分钟",
      "value": "min"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小时",
      "value": "hour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "天",
      "value": "day"
    }
  })], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-split"
  }, [_c('div', {
    staticClass: "app-ad-row"
  }, [_c('div', {
    staticClass: "app-ad-left"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 跑步结束-插屏")]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-switch"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#409eff",
      "inactive-color": "#c0c4cc"
    },
    model: {
      value: (_vm.addForm.appAds.runEndPop.enabled),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.runEndPop, "enabled", $$v)
      },
      expression: "addForm.appAds.runEndPop.enabled"
    }
  })], 1)]), _vm._v(" "), (_vm.addForm.appAds.runEndPop.enabled) ? _c('div', {
    staticClass: "interval-grid"
  }, [_c('div', {
    staticClass: "interval-line"
  }, [_c('div', {
    staticClass: "interval-label"
  }, [_vm._v("冷启动间隔")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 9999,
      "step": 1,
      "precision": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.addForm.appAds.runEndPop.cold),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.runEndPop, "cold", $$v)
      },
      expression: "addForm.appAds.runEndPop.cold"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "interval-unit",
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.addForm.appAds.runEndPop.coldUnit),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.runEndPop, "coldUnit", $$v)
      },
      expression: "addForm.appAds.runEndPop.coldUnit"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "秒",
      "value": "sec"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "分钟",
      "value": "min"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小时",
      "value": "hour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "天",
      "value": "day"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "interval-line"
  }, [_c('div', {
    staticClass: "interval-label"
  }, [_vm._v("热启动间隔")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 9999,
      "step": 1,
      "precision": 0,
      "controls-position": "right"
    },
    model: {
      value: (_vm.addForm.appAds.runEndPop.hot),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.runEndPop, "hot", $$v)
      },
      expression: "addForm.appAds.runEndPop.hot"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "interval-unit",
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.addForm.appAds.runEndPop.hotUnit),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.runEndPop, "hotUnit", $$v)
      },
      expression: "addForm.appAds.runEndPop.hotUnit"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "秒",
      "value": "sec"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "分钟",
      "value": "min"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "小时",
      "value": "hour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "天",
      "value": "day"
    }
  })], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-row"
  }, [_c('div', {
    staticClass: "app-ad-left"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 首页-信息流")]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-switch"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#409eff",
      "inactive-color": "#c0c4cc"
    },
    model: {
      value: (_vm.addForm.appAds.homeFeed.enabled),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.homeFeed, "enabled", $$v)
      },
      expression: "addForm.appAds.homeFeed.enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-row"
  }, [_c('div', {
    staticClass: "app-ad-left"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 跑步结束-信息流")]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-switch"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#409eff",
      "inactive-color": "#c0c4cc"
    },
    model: {
      value: (_vm.addForm.appAds.runEndFeed.enabled),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.runEndFeed, "enabled", $$v)
      },
      expression: "addForm.appAds.runEndFeed.enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-row"
  }, [_c('div', {
    staticClass: "app-ad-left"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 我的-信息流")]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-switch"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#409eff",
      "inactive-color": "#c0c4cc"
    },
    model: {
      value: (_vm.addForm.appAds.mineFeed.enabled),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.mineFeed, "enabled", $$v)
      },
      expression: "addForm.appAds.mineFeed.enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-row"
  }, [_c('div', {
    staticClass: "app-ad-left"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 悬浮窗")]), _vm._v(" "), _c('div', {
    staticClass: "app-ad-switch"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#409eff",
      "inactive-color": "#c0c4cc"
    },
    model: {
      value: (_vm.addForm.appAds.floatingWindow.enabled),
      callback: function($$v) {
        _vm.$set(_vm.addForm.appAds.floatingWindow, "enabled", $$v)
      },
      expression: "addForm.appAds.floatingWindow.enabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 适用人群\n               ")]), _vm._v(" "), _c('div', {
    staticClass: "crowd-options"
  }, _vm._l((_vm.crowdOptions), function(opt) {
    return _c('div', {
      key: opt.id,
      staticClass: "crowd-option",
      class: {
        'is-selected': _vm.isCrowdSelected(opt.id)
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectCrowd(opt.id)
        }
      }
    }, [_vm._v("\n                     " + _vm._s(opt.name) + "\n                  ")])
  }), 0)], 2), _vm._v(" "), _c('el-form-item', [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" 适用校区\n               ")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.addForm.campusScope),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "campusScope", $$v)
      },
      expression: "addForm.campusScope"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "all"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "partial"
    }
  }, [_vm._v("部分校区配置")])], 1), _vm._v(" "), (_vm.addForm.campusScope === 'partial') ? _c('div', {
    staticClass: "campus-partial"
  }, [_c('div', {
    staticClass: "campus-select-row"
  }, [_c('el-select', {
    staticClass: "campus-select",
    attrs: {
      "placeholder": "请选择校区",
      "filterable": ""
    },
    model: {
      value: (_vm.campusForm.unid),
      callback: function($$v) {
        _vm.$set(_vm.campusForm, "unid", $$v)
      },
      expression: "campusForm.unid"
    }
  }, _vm._l((_vm.effectiveCampusZoneList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "campus-add-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAddCampusZones
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "campus-card-wrap"
  }, _vm._l((_vm.campusModels), function(item) {
    return _c('div', {
      key: item.unid,
      staticClass: "campus-dialog-item"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteCampus(item.unid)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "campus-card-footer"
  }, [_vm._v("\n                     共 " + _vm._s(_vm.campusModels.length) + " 个校区\n                  ")])]) : _vm._e()], 2)], 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visibleProxy = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSaveAddStrategy
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79951f6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/AdManagement/Components/AdAddStrategyDialog.vue
// module id = 1081
// module chunks = 0